import type { NodeSn } from '../../../nodes/index';
import type { Security } from '../../../pathLookup';
import {
  type KeyOfType,
  getValueFromKeyOfType,
} from '../../../types/KeyOfType';
import { createDefaultFilter } from '../../filters/createDefaultFilter';
import { createTextFilter } from '../../filters/types/textFilter';
import type { TableColumnBase } from '../TableColumnBase';
import {
  type TableDataColumnConfig,
  pickTableColumnConfig,
} from '../TableColumnConfig';

export type TableColumnFormatSecurity<TRow> = {
  type: 'security';
  field: KeyOfType<TRow, string>;
  hostSnField: KeyOfType<TRow, NodeSn>;
  ruleNameField: KeyOfType<TRow, string>;
  highlightedRuleIndexField?: KeyOfType<TRow, number>;
  securityType: Security.SecurityType;
};

export const createSecurityColumn = <TRow>(
  config: TableDataColumnConfig<TRow, string> & {
    hostSnField: KeyOfType<TRow, NodeSn>;
    ruleNameField: KeyOfType<TRow, string>;
    highlightedRuleIndexField?: KeyOfType<TRow, number>;
    securityType: Security.SecurityType;
    array?: false;
  },
): TableColumnBase<TRow, TableColumnFormatSecurity<TRow>> => ({
  ...pickTableColumnConfig(config),
  format: {
    type: 'security',
    field: config.key,
    hostSnField: config.hostSnField,
    ruleNameField: config.ruleNameField,
    highlightedRuleIndexField: config.highlightedRuleIndexField,
    securityType: config.securityType,
  },
  csvStringDependencies: [config.key],
  webDependencies: [
    config.key,
    config.hostSnField,
    config.ruleNameField,
    ...(config.highlightedRuleIndexField
      ? [config.highlightedRuleIndexField]
      : []),
  ],
  toCsvString: (row) => getValueFromKeyOfType(row, config.key),
  filter: createDefaultFilter(config.filter, createTextFilter()),
});
